import { axios, get, post, put } from './baseAxios';
import { API_MEDIA } from '../utils/urls';

const url = API_MEDIA;
export const getMedia = (id) => get(`${url}/${id}`);
export const getMedias = (params) => get(url, { params });
export const updateMedia = (id, request) => put(`${url}/${id}`, request);
export const createMedia = (request) => post(url, request);
export const deleteMedia = (id) => axios.delete(`${url}/${id}`);
